module.exports = function getResource(label, vars = []) {
    const resources = { error: 'Error' };

    return resources[label];
};
